module.exports = __webpack_public_path__ + "static/media/logo-horizontal.5c7196ed.png";